
function FourOhFourScreen() {
    return (
      <main>
          <h1>Error 404, Cannot Find Page</h1>
          <p>Please check the URL you are looking for</p>
      </main>
    )
  }
  
  export default FourOhFourScreen